import 'react-toastify/dist/ReactToastify.css';

import React, { useEffect } from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import styled from 'styled-components';

import { useTranslateErrorMessage } from '../common/';

// Estilos personalizados para el contenedor de Toasts
const StyledContainer = styled(ToastContainer).attrs({
  position: 'bottom-right',
})`
  .Toastify__toast {
    margin: 0;
    padding: 0;
  }
  .Toastify__close-button {
    color: grey;
  }
  .Toastify__toast--error,
  .Toastify__toast--success {
    color: black;
    background-color: whitesmoke;
  }
  .Toastify__toast-body {
    margin: 0;
    padding: 0;
  }
  .Toastify__progress-bar {
    background-color: #5138ef;
  }
  .Toastify__progress-bar--success {
    background-color: #28a745;
  }
  .Toastify__progress-bar--error {
    background-color: #dc3545;
  }
`;

// Contenedor del mensaje con ícono personalizado
const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 1em 1em 1em 2.5em;
  justify-content: center;
`;

const IconContainer = styled.div`
  position: absolute;
  top: 0;
  left: -2em;
`;

const CustomMessage = ({ message, type }) => {
  const { t } = useTranslation(['glossary']);
  return (
    <MessageContainer>
      <div className="position-relative">
        <p className="m-0 py-0">
          <strong>{t(type, { ns: 'glossary' })}</strong>
        </p>
        <IconContainer>
          {type === 'success' ? (
            <CheckCircleIcon className="text-success" />
          ) : (
            <ErrorIcon className="text-danger" />
          )}
        </IconContainer>
      </div>
      <div>
        <p className="m-0 py-0">{message}</p>
      </div>
    </MessageContainer>
  );
};

const CustomToast = () => {
  const message = useSelector((state) => state.toast.message);
  const navigate = useNavigate();

  const { translateMessage } = useTranslateErrorMessage();

  useEffect(() => {
    const { body: code, type } = message;

    if (code === 'Unauthorized') {
      navigate(0);
    } else if (type === 'success') {
      toast.success(
        <CustomMessage message={translateMessage(code)} type="success" />,
        { icon: false }
      );
    } else if (type === 'error') {
      toast.error(
        <CustomMessage message={translateMessage(code)} type="error" />,
        { icon: false }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  return (
    <StyledContainer
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable={false}
      pauseOnHover
    />
  );
};

export default CustomToast;

export { setMessage } from './toastSlice';
export { NOTIFICATION_TYPES } from '../../config/consts/commons';
